import { render, staticRenderFns } from "./ChatIdleCountdown.vue?vue&type=template&id=09a94576&"
import script from "./ChatIdleCountdown.vue?vue&type=script&lang=js&"
export * from "./ChatIdleCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports